import { render, staticRenderFns } from "./A9Info.vue?vue&type=template&id=603eadba&"
import script from "./A9Info.vue?vue&type=script&lang=ts&"
export * from "./A9Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports